import React from 'react'
import MainLeaderboardOptionContainer from '@feature/leaderboard/pages/ScreenMain/MainLeaderboardHeaders/MainLeaderboardOptionContainer'
import LeaderboardScreenMainTableContainer from '@feature/leaderboard/pages/ScreenMain/LeaderboardScreenMainTableContainer'
import useScreenLog from '@hook/useScreenLog'

interface IProps {}

const LeaderboardScreenMain: React.FC<IProps> = ({}) => {
    const {} = useScreenLog({pageName: 'leaderboard_main'})
    return (
        <div>
            <MainLeaderboardOptionContainer />
            <LeaderboardScreenMainTableContainer />
        </div>
    )
}

export default LeaderboardScreenMain
